import { Fragment, useState, useRef } from 'react'
import { Transition } from '@headlessui/react'
import Cta from '../components/Cta'

import UserService from '../services/UserService'
import { useNotification } from '../providers/NotificationProvider';
import LoadingBar from 'react-top-loading-bar';

const formClass = "appearance-none block w-full px-8 py-4 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 font-primary text-login-form-input";

function ForgotForm() {
  const [ notification, notificationDispatch ] = useNotification();
  const [form, setFormData] = useState({
    email: ""
  });

  const loadingBarRef = useRef(null);

  const handleSubmit = (evt) => {
    evt.preventDefault();
    loadingBarRef.current.continuousStart();
    UserService.forgotPassword(form.email).then((response) => {
      if (response.data.errors) {
        notificationDispatch({ type: 'show_notification', payload: { message: "Registration Error" } });
      } else {
        notificationDispatch({ type: 'show_notification', payload: { message: "Password reset instructions sent to email." } });
      }
      loadingBarRef.current.complete();
    });
  }

  return (
    <div className="mt-6 sm:mx-auto md:w-120">
      <LoadingBar color='#0173FF' ref={loadingBarRef} />

      <div className="bg-white px-4 sm:rounded-lg sm:px-10">
        <form className="space-y-6" onSubmit={ handleSubmit } method="POST">
          <input 
            id="email"
            type="email"
            placeholder='Email'
            className={formClass}
            value={form.email}
            onChange={(evt) => setFormData({...form, email: evt.target.value})}
            required
          />
          <div>
            <button
              type="submit"
              className="inline-flex items-center justify-center px-14 py-4 border border-transparent font-cta-label text-cta-label-mobile md:text-cta-label font-medium rounded-full text-white bg-blue-500 hover:bg-blue-400 disabled:bg-grey-light"
            >Confirm</button>
          </div>
        </form>
      </div>

    </div>
  )
}

export default ForgotForm;
